import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Send } from "lucide-react";
import api from "../../lib/apiClient";
import { ProHeader, StatusBadge, money, fmtDate, Loading, Empty } from "./proUi";

// Mes propositions envoyées (GET /marketplace/my-proposals).
export default function ProPropositions() {
  const [props, setProps] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/marketplace/my-proposals").then((r) => setProps(r.data.proposals)).catch(() => setProps([])); }, []);
  if (props === null) return <Loading />;
  return (
    <div className="space-y-6" data-testid="pro-propositions-page">
      <ProHeader eyebrow="Mon activité" title="Mes propositions"
        subtitle="Suis les propositions que tu as envoyées aux membres." />
      {props.length === 0 ? (
        <Empty icon={Send} title="Aucune proposition envoyée" hint="Parcours les demandes du Marché pour proposer tes services." testid="pro-propositions-empty" />
      ) : (
        <div className="space-y-3">
          {props.map((p) => (
            <button key={p.id} onClick={() => p.request_id && nav(`/marketplace/requests/${p.request_id}`)}
              className="w-full text-left bg-[#18181E] border border-zinc-800 rounded-2xl p-5 card-hover" data-testid={`proposition-${p.id}`}>
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-display font-bold text-zinc-100">{p.request_title || "Demande"}</h3>
                <StatusBadge status={p.request_status} />
              </div>
              <p className="text-sm text-zinc-400 mt-1 line-clamp-2">{p.message}</p>
              <div className="flex items-center gap-3 mt-3 text-xs text-zinc-500">
                {p.price != null && <span className="text-amber-400 font-mono">{money(p.price)}</span>}
                {p.delay && <span>Délai : {p.delay}</span>}
                <span className="ml-auto">{fmtDate(p.created_at)}</span>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
